export const checkHeight = (data: Array<any>) => {
    if (data.length < 10) {
        return 500;
    }
    if (data.length > 50) {
        return 1700;
    }
    return data.length * 31 + 150;
};
